const env = process.env.GIBOBS_ENV || process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const environment = require(`./Environments/env.${env.trim()}.json`);
environment.env = env;

export default environment;
